<div class="quick-search-container">
  <span class="quick-search-input" [formGroup]="form" *ngIf="!selectedResult">
    <input
      id="quick-search-input"
      formControlName="filterTerm"
      [attr.disabled]="doingFilterLookup ? '' : null"
      placeholder="{{ inputPlaceholder }}"
    />
    <span class="search-button" (click)="doSearch()">
      <span id="search-button" class="icon icon-search"></span>
    </span>
    <div
      id="lookup-dropdown"
      class="lookup"
      *ngIf="filterLookupResults.length"
      (click)="closeLookUp($event)"
    >
      <ul>
        <li
          *ngFor="let lookupResult of filterLookupResults"
          (mousedown)="selectLookupResult(lookupResult)"
        >
          {{ lookupResult[labelKey] }}
        </li>
      </ul>
    </div>
  </span>

  <span class="lookup-result" *ngIf="selectedResult">
    {{ selectedResult[labelKey] }}
    <button href="" (click)="resetInput()">x</button>
  </span>
</div>
